import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/tokens/$token')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_public/_layout/tokens/$token"!</div>
}
